import React from "react";

const Navbar = () => {
  return (
    <nav
      className="navbar navbar-light px-3 py-2 shadow-sm custom-emerald d-flex justify-content-center"
      style={{  marginBottom: "0" }}
    >
       
        <div className="text-center text-white">
          <small className="d-block">Today is</small>
          <strong>{new Date().toDateString()}</strong>
        </div>
        
    </nav>
  );
};

export default Navbar;